const ANNOUNCEMENT_COLORS = {
  1: {
    borderColor: "#1976d2",
    headerBg: "#1976d2",
    headerText: "#ffffff",
    bodyBg: "#e3f2fd",
    icon: "ℹ️",
  },
  2: {
    borderColor: "#ed6c02",
    headerBg: "#ed6c02",
    headerText: "#ffffff",
    bodyBg: "#fff3e0",
    icon: "⚠️",
  },
  3: {
    borderColor: "#d32f2f",
    headerBg: "#d32f2f",
    headerText: "#ffffff",
    bodyBg: "#fdecea",
    icon: "❌",
  },
  4: {
    borderColor: "#2e7d32",
    headerBg: "#2e7d32",
    headerText: "#ffffff",
    bodyBg: "#edf7ed",
    icon: "✅",
  },
};

const DEFAULT_COLORS = ANNOUNCEMENT_COLORS[1];

export function getAnnouncementColors(type) {
  return ANNOUNCEMENT_COLORS[type] || DEFAULT_COLORS;
}

export default ANNOUNCEMENT_COLORS;
